import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Filter } from 'src/components/shared-components/class/general-classes/filter';
import { EventService } from 'src/service/event.service';
import { FilterBaseComponent } from '../filter-base-component';

@Component({
    selector: 'app-filter-date-period',
    templateUrl: './filter-date-period.component.html',
    styleUrls: ['./filter-date-period.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterDatePeriodComponent extends FilterBaseComponent implements OnInit {
  public value: string;

  constructor(protected _eventService: EventService, protected _translateService: TranslateService) {
    super(_eventService, _translateService);
  }

  ngOnInit() {
    if (this.Filter.InputValue !== "") {
      this.value = this.Filter.InputValue;
      this.valueChanged(this.value);
    }
    this.baseSubscribeTranslationEvent();
    this.baseLoadTranslation();
  }

  ngOnDestroy(): void {
    this.baseOnDestroy()
  }

  // On ionBlur send value of filter
  public valueChanged(event) {
    this._eventService.OnFilterValueChanged.next([this.Filter, event == null ? '' : event.toString()]);
  }
}
